module.exports = __webpack_public_path__ + "static/media/mail-outlined-gray.d0f97b7d.svg";